module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-7.2505c630.jpg";